<template>
  <v-container clipped fill-height fixed fluid class="pa-0 mt-5">
    <v-global-progress-bar namespace="featureRules" :flags="progressBarFlags" />
    <v-feature-rules-toolbar />
    <v-feature-rules-sidebar />
    <v-feature-rules-content />
  </v-container>
</template>

<script>
import VFeatureRulesContent from "./content/Layout.vue";
import VFeatureRulesSidebar from "./sidebar/Layout";
import VFeatureRulesToolbar from "./toolbar/Layout";
import VGlobalProgressBar from "@/components/progress/GlobalProgressBar.vue";

export default {
  components: {
    VFeatureRulesContent,
    VFeatureRulesSidebar,
    VFeatureRulesToolbar,
    VGlobalProgressBar
  },
  data: () => ({
    progressBarFlags: [
      "loadingBrands",
      "loadingClassifications",
      "loadingCreateFeature",
      "loadingFeatures",
      "loadingFeatureValues",
      "loadingItems",
      "loadingRemoveFeature",
      "loadingSaveRule",
      "loadingRules"
    ]
  })
};
</script>
